// Mock data for Golden Bridge Business LLC clone

export const IMAGES = {
  logo: "/assets/logo.png",
  founder: "/assets/founder.jpeg",
  knowmoDash: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzg3NDg3NDQyfDA&ixlib=rb-4.1.0&q=85",
  knowmoInventory: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzg3NDg3NDQyfDA&ixlib=rb-4.1.0&q=85",
  emberServers: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
  emberPlant: "https://images.unsplash.com/photo-1509390288171-ce2088f7d08e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
  emberRefinery: "https://images.pexels.com/photos/15970032/pexels-photo-15970032.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  networkAbstract: "https://images.unsplash.com/photo-1664854953181-b12e6dda8b7c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  strategyMeeting: "https://images.pexels.com/photos/30854660/pexels-photo-30854660.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400"
};

export const NAV_LINKS = [
  { label: "Overview", href: "#overview" },
  { label: "Leadership", href: "#leadership" },
  { label: "Strategic Advisory", href: "#advisory" },
  { label: "KnowMo", href: "#knowmo", badge: "SAAS" },
  { label: "Ember", href: "#ember", badge: "COMPUTE" }
];

export const HERO = {
  eyebrow: "Muscat \u2022 Sultanate of Oman",
  titleLead: "Architecting Capital Clarity,",
  titleAccent: "Liquid Intelligence",
  titleTail: "& Sustainable Compute.",
  description:
    "Golden Bridge Business LLC (GBB LLC) is an Oman-based strategic enterprise operating at the intersection of executive financial governance, proprietary software technology, and energy monetization. We partner with business leaders and asset owners across the GCC region to turn complex operational challenges into structured, high-value outcomes."
};

export const WHO_WE_ARE = {
  eyebrow: "Who We Are",
  title: "Bridging Corporate Strategy & Digital Infrastructure",
  body: "Founded in Muscat, Golden Bridge Business LLC bridges the gap between traditional corporate strategy and forward-looking digital infrastructure. Rather than offering transactional or generic advice, GBB LLC engages deeply with corporate balance sheets, operational workflows, and energy assets. Our multidimensional focus allows us to deliver high-level capital clarity, engineer specialized financial SaaS tools, and spearhead innovative flare energy compute projects.",
  pillars: [
    { title: "Capital Advisory", text: "Institutional-grade financial governance and strategy." },
    { title: "KnowMo SaaS", text: "Proprietary autonomous cash intelligence software." },
    { title: "Ember Compute", text: "Flare gas monetization into AI compute power." }
  ]
};

export const LEADERSHIP = {
  eyebrow: "Executive Leadership",
  title: "Driven by Corporate Vision & Execution",
  name: "Muhammad Danish",
  role: "Founder & Managing Partner",
  bio: "Bringing extensive expertise in corporate financial engineering, feasibility modeling, valuation, and executive risk management across Oman and the GCC region. Under his leadership, Golden Bridge Business LLC delivers high-impact advisory solutions while pioneering proprietary financial technology (KnowMo) and green energy compute infrastructure (Ember).",
  linkedin: "https://www.linkedin.com/in/muhammad-danish-277a21102"
};

export const STATS = [
  { value: "100%", label: "Capital Visibility Commitment" },
  { value: "12 Months", label: "Predictive Cash Modeling" },
  { value: "Zero Flaring", label: "Ember Off-Grid Target" }
];

export const ADVISORY = {
  eyebrow: "Enterprise Governance & Strategy",
  title: "Strategic Capital Architecture & Executive Advisory",
  intro:
    "In today's dynamic GCC economic climate, corporate leaders require institutional precision rather than generic consulting checklists. Golden Bridge Business LLC provides high-impact strategic advisory tailored to safeguard enterprise value, strengthen financial governance, and maximize capital efficiency.",
  services: [
    {
      icon: "LineChart",
      title: "Market Viability & Project Feasibility Modeling",
      text: "Before committing significant capital to new ventures, expansions, or asset acquisitions, leadership must stress-test key assumptions. We construct comprehensive financial models, run sensitivity analyses on payback timelines, and validate market entry parameters to minimize risk."
    },
    {
      icon: "Scale",
      title: "Balance Sheet & Liquidity Engineering",
      text: "Optimal capital structure is essential for long-term resilience. We analyze working capital velocity, structure debt/equity allocations, and implement liquidity safeguards that protect business operations from macroeconomic shifts and seasonal revenue fluctuations."
    },
    {
      icon: "Building2",
      title: "Enterprise Valuation & Transaction Strategy",
      text: "Accurate asset and business valuation is critical for mergers, acquisitions, restructuring, and shareholder buyouts. Utilizing rigorous DCF and market-based methodologies, we deliver objective valuation frameworks that withstand institutional scrutiny."
    },
    {
      icon: "ShieldCheck",
      title: "Sovereign Compliance & Oman Tax Frameworks",
      text: "Navigating regional regulatory demands\u2014including Oman VAT, corporate tax alignment, and sovereign receivables tracking\u2014requires specialized knowledge. We establish robust internal governance controls that ensure seamless compliance while optimizing tax efficiency."
    }
  ]
};

export const KNOWMO = {
  eyebrow: "Proprietary Web Application",
  title: "KnowMo \u2014 Autonomous Cash Command Intelligence",
  intro:
    "KnowMo is a web-based financial intelligence application developed by Golden Bridge Business LLC. Acting as an autonomous fractional CFO, KnowMo eliminates manual spreadsheet errors by providing real-time cash runway surveillance, predictive payment timing analysis, and working capital optimization.",
  modules: [
    {
      tag: "MODULE 01",
      title: "Executive Cash Command & Runway Surveillance",
      text: "Provides real-time visibility into your cash burn rate, active liquidity, and historical AR/AP payment behaviors. KnowMo automatically flags critical cash gaps before they materialize, allowing leadership to take proactive corrective action.",
      points: ["Real-time cash burn tracking", "AR/AP behavior analytics", "Predictive gap alerts"]
    },
    {
      tag: "MODULE 02",
      title: "Inventory & Strategic Disbursement Intelligence",
      text: "Uncovers capital trapped in warehouse SKUs and slow-moving inventory. KnowMo prioritizes accounts payable bills based on vendor penalty risks, grace windows, and early-payment discount opportunities to maximize cash retention.",
      points: ["Trapped capital detection", "Vendor penalty prioritization", "Early-payment optimization"]
    }
  ]
};

export const EMBER = {
  eyebrow: "Energy & Infrastructure Initiative",
  title: "Ember \u2014 Converting Stranded Flare Gas into AI Compute",
  intro:
    "Ember is Golden Bridge Business LLC's specialized flare energy monetization brand. We partner with upstream oil & gas operators to map stranded natural gas flare sites and deploy mobile, containerized data pods directly at wellheads\u2014converting unutilized energy into compute power for AI model training.",
  steps: [
    {
      num: "01",
      title: "Upstream Flare Site Mapping",
      text: "Identifying remote wellhead locations with consistent flare volumes, evaluating gas composition, and measuring daily throughput potential for off-grid power generation."
    },
    {
      num: "02",
      title: "Modular Off-Grid Data Pods",
      text: "Deploying ruggedized, mobile, liquid-cooled containerized mini data centers built specifically to withstand extreme ambient heat and harsh desert conditions in Oman."
    },
    {
      num: "03",
      title: "AI Model Training Power",
      text: "Converting raw flare gas kilowatts into secure, high-density computing loads for artificial intelligence, machine learning model training, and decentralized network processing."
    }
  ]
};

export const CONTACT = {
  eyebrow: "Direct Executive Engagement",
  title: "Connect with Golden Bridge Business LLC",
  intro:
    "Reach out to our leadership team for strategic capital advisory engagements, KnowMo SaaS platform access, or Ember flare gas compute site partnerships across Oman and the GCC.",
  address: "Azaiba, Muscat, Sultanate of Oman",
  email: "operations@goldenbridgebusinesses.com",
  phone: "+968 97003083",
  subjects: [
    "Strategic Capital Advisory",
    "KnowMo SaaS Access Request",
    "Ember Flare Compute Site Partnership",
    "General Inquiry"
  ]
};